import { useEffect } from "react";
/** @internal */
export const useTriggerReadyCallback = (isReady, onReady) => {
    useEffect(() => {
        if (isReady && onReady) {
            onReady();
        }
    }, [isReady]);
};
/** @internal */
export default useTriggerReadyCallback;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVHJpZ2dlclJlYWR5Q2FsbGJhY2suanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9BcHBCb290c3RyYXAvaG9va3MvdXNlVHJpZ2dlclJlYWR5Q2FsbGJhY2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUVsQyxnQkFBZ0I7QUFDaEIsTUFBTSxDQUFDLE1BQU0sdUJBQXVCLEdBQUcsQ0FDckMsT0FBZ0IsRUFDaEIsT0FBb0IsRUFDZCxFQUFFO0lBQ1IsU0FBUyxDQUFDLEdBQUcsRUFBRTtRQUNiLElBQUksT0FBTyxJQUFJLE9BQU8sRUFBRSxDQUFDO1lBQ3ZCLE9BQU8sRUFBRSxDQUFDO1FBQ1osQ0FBQztJQUNILENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7QUFDaEIsQ0FBQyxDQUFDO0FBRUYsZ0JBQWdCO0FBQ2hCLGVBQWUsdUJBQXVCLENBQUMifQ==